export default {
  'upload.image': {
    required: 'Please upload document or image'
  },
  password: {
    min: '{_field_} is too short, you want to get hacked?'
  }
};
